/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Confirm_OrderInputs */

const vi_dashboard_sales_confirm_order = /** @type {(inputs: Dashboard_Sales_Confirm_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đơn`)
};

/**

* @param {Dashboard_Sales_Confirm_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_confirm_order = /** @type {((inputs?: Dashboard_Sales_Confirm_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Confirm_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_confirm_order(inputs)
});